<ng-container *ngIf="report$ | async as report">
  <iframe [src]="report.safeUrl" frameborder="0" style="width: 100%; height: 900px;" scrolling="yes"></iframe>
</ng-container>
